import { format } from "date-fns";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { getEvent, getEventById } from "../api/crud";
import xlsxParser from "xls-parser";
import { useForm } from "react-hook-form";
import { Button } from "@mui/material";
import ModalView from "../Components/ModalView";

const EventById = () => {
  const { REACT_APP_BASE_NAME } = process.env;

  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [eventLog, setEventLog] = useState([]);
  const [eventDetail, setEventDetail] = useState("");
  const [onlyCheckin, setOnlyCheckin] = useState(false);
  const [modalPreviewOpen, setModalPreviewOpen] = useState(false);
  const [importList, setImportList] = useState([]);

  const { register, watch } = useForm();
  const watchFile = watch("file");

  const getEventList = async (eventId) => {
    const response = await getEvent();

    const matching = response.find((event) => event.id == eventId);
    setEventDetail(matching);
  };

  const getData = async (event_id) => {
    const response = await getEventById(event_id);

    const checkinType = _.uniqBy(
      response
        .filter((event) => event.type === "เข้า")
        .map((el) => {
          return {
            st_id: el.st_id,
            checkin: {
              ...el,
            },
          };
        }),
      "st_id"
    );

    const checkoutType = response
      .filter((event) => event.type === "ออก")
      .map((el) => {
        return {
          st_id: el.st_id,
          checkout: {
            ...el,
          },
        };
      });

    const mapData = checkinType.map((item) => {
      const matchStId = checkoutType.find((st) => st.st_id === item.st_id);

      return {
        ...item,
        ...matchStId,
      };
    });

    setOnlyCheckin(!checkoutType.length);

    setEventLog(mapData);

    console.log({ mapData });
  };

  useEffect(() => {
    if (id) {
      getData(id);
      getEventList(id);
    }
  }, [id]);

  const onInsertXls = () => {
    setModalPreviewOpen(true);
    const file = watchFile[0];

    if (file) {
      xlsxParser.onFileSelection(file).then(async (data) => {
        setImportList(data.Sheet1);
      });
    }
  };

  const displayInsertXls = (
    <div className="d-flex align-items-center py-3">
      <a
        href={`${REACT_APP_BASE_NAME}/assets/file/template_event_detail.xlsx`}
        className="btn ms-2  text-nowrap"
        target="_blank"
      >
        ตัวอย่างไฟล์
      </a>
      <input
        type="file"
        className="form-control mx-2"
        {...register("file")}
        style={{ width: "250px" }}
      />
      <Button variant="contained" onClick={onInsertXls} disabled={!watchFile}>
        นำเข้า
      </Button>
    </div>
  );

  const displayModalPreview = (
    <ModalView
      isModaOpen={modalPreviewOpen}
      setIsModalOpen={setModalPreviewOpen}
      title="นำเข้าข้อมูล"
    >
      <form action="./add-event-register.php" method="post">
        <div
          style={{
            maxHeight: "60vh",
            overflow: "scroll",
          }}
        >
          <table className="table" style={{ width: "500px" }}>
            <thead>
              <tr>
                <th>รหัสนักศึกษา</th>
                <th>Type</th>
                <th>วัน - เวลา</th>
                <th>Comment</th>
              </tr>
            </thead>
            <tbody>
              {!!importList.length &&
                importList.map((el) => {
                  return (
                    <tr>
                      <td>
                        {el.st_id}
                        <input
                          name="st_id[]"
                          className="d-none"
                          value={el.st_id}
                        />
                      </td>
                      <td>
                        {el.type}
                        <input
                          name="type[]"
                          className="d-none"
                          value={el.type}
                        />
                      </td>
                      <td>
                        {el.checkin_date}
                        <input
                          name="checkin_date[]"
                          className="d-none"
                          value={el.checkin_date}
                        />
                      </td>
                      <td>
                        {el.comment}
                        <input
                          name="Comment[]"
                          className="d-none"
                          value={el.comment}
                        />
                        <input
                          name="event_id[]"
                          className="d-none"
                          value={id}
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <Button type="submit">บันทึกข้อมูล</Button>
      </form>
    </ModalView>
  );

  return (
    <div>
      {displayModalPreview}
      <div className="my-4">
        <h2>{eventDetail.title}</h2>
        <h4>{eventDetail.place}</h4>
        <h4>{eventDetail.expert}</h4>
        <p>จำนวนคนเข้าอบรม {eventLog.length}</p>
        {displayInsertXls}
      </div>
      <table className="table ">
        <thead className="table-primary">
          <tr>
            <th></th>
            <th>รหัสนิสิต</th>
            <th>ชื่อ</th>
            <th>สาขา</th>
            <th>วัน - เวลา</th>
            <th>Comment</th>
          </tr>
        </thead>
        <tbody>
          {eventLog?.map((item, index) => {
            return (
              <tr key={item.st_id}>
                <th>{index + 1}</th>
                <th>{item.st_id}</th>
                <td>{item?.checkin?.student?.st_name}</td>
                <td>{item?.checkin?.student?.b_name}</td>
                <td>
                  <div>
                    {!!item?.checkin &&
                      format(
                        new Date(item?.checkin?.checkin_date.replace(" ", "T")),
                        "dd MMMM yyyy HH:mm"
                      )}{" "}
                    {!!item?.checkout &&
                      !onlyCheckin &&
                      `- ${format(
                        new Date(
                          item?.checkout?.checkin_date.replace(" ", "T")
                        ),
                        "HH:mm"
                      )}`}
                    {!item?.checkout && !onlyCheckin && (
                      <span className="text-danger">- ไม่ได้เช็คออก</span>
                    )}
                  </div>
                </td>
                <td>
                  <div>{item?.checkin?.comment}</div>
                  <div>{item?.checkout?.comment}</div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default EventById;
